import { render } from "./click-outside.vue?vue&type=template&id=273054ae"
import script from "./click-outside.vue?vue&type=script&lang=js"
export * from "./click-outside.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__